// extracted by css-extract-rspack-plugin
export default {"deviceType":"_b4fe073"};